import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { SortsPropType, columnConfigPropType } from '../Table/propTypes';
import { TABLE_SETTING } from '../../constants/Tables';
import NoResults from '../NoResults';
import { renderablePropType } from '../../utils/propTypes';
import Table from '../Table';

function ProductsTable({
	products = [],
	total = 0,
	sorts,
	onSort,
	onPageChange,
	pagination = { limit: TABLE_SETTING.DEFAULT_PAGE_SIZE, page: 0 },
	columnConfig,
	columnOrder,
	isLoading,
	children,
	columnVisibility,
}) {
	const { t } = useTranslation('products');
	const navigate = useNavigate();

	return (
		<Table
			items={products}
			columnConfig={columnConfig}
			noResultsContent={<NoResults>products</NoResults>}
			renderColumnHeader={(key) => t(`columns.${key}`)}
			TableRowProps={({ Item_Number: itemNumber }) => ({
				hover: true,
				style: { cursor: 'pointer' },
				onClick: () => navigate(`/products/${itemNumber}`),
				key: itemNumber,
			})}
			columnOrder={columnOrder}
			columnVisibility={columnVisibility}
			isLoading={isLoading}
			pagination={pagination}
			total={total}
			sorts={sorts}
			onSort={onSort}
			onPageChange={onPageChange}
		>
			{children}
		</Table>
	);
}

ProductsTable.propTypes = {
	products: PropTypes.array,
	total: PropTypes.number,
	sorts: SortsPropType,
	onSort: PropTypes.func,
	onPageChange: PropTypes.func.isRequired,
	pagination: PropTypes.shape({
		limit: PropTypes.number.isRequired, // rows per page
		page: PropTypes.number.isRequired, // current page
	}),

	columnConfig: columnConfigPropType,
	columnOrder: PropTypes.array,
	isLoading: PropTypes.bool,
	children: renderablePropType,
	columnVisibility: PropTypes.object.isRequired,
};

export default ProductsTable;
